import { AuthenticatedRoute, RequireOrganization } from "../components/ProtectedRoute";
import { DashboardLayout } from "../components/DashboardLayout";

export default [AuthenticatedRoute, RequireOrganization, DashboardLayout];